// extracted by mini-css-extract-plugin
export default {"WebhookUrlResponse":"_WebhookUrlResponse--g4hRS","Loading":"_Loading--YtbXc","Error":"_Error--v0hdD","StatusCode":"_StatusCode--lgIOI","ErrorCode":"_ErrorCode--L6rlT"};